import api from "../../../services/axiosConfig";
import { MODULE_INSTANCE_CONFIG, checkDependencies } from "./InstanceConfig";

const toggleSingle = async (title, action, config, containerId, toast) => {
  const endpoint =
    action === "destroy" && config.destroyMethod === "delete"
      ? "delete"
      : "post";
  const url = `/instances/${config.url}/${action}`;
  const method =
    action === "destroy" && config.destroyMethod === "delete"
      ? api.delete
      : api.post;
  const response = await method(
    url,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  );
  return response.data;
};

const extractInstance = (responseData, config, title, containerId) => {
  const data =
    responseData?.data?.instance || responseData?.data?.instances || [];
  const instances = Array.isArray(data) ? data.flat() : [data];
  const filtered = config.containerFilter
    ? instances.find((i) => i.containerName?.includes(config.containerFilter))
    : instances[0];
  return filtered || {};
};

export const toggleStatus = async (
  title,
  cardStatus,
  setCardStatus,
  setLoading,
  containerIds,
  setContainerIds,
  toast,
  setExposedPorts,
) => {
  const currentStatus = cardStatus[title];
  const containerId = containerIds[title];
  const config = MODULE_INSTANCE_CONFIG[title];

  if (!config) {
    toast.current?.show({
      severity: "error",
      summary: "Error",
      detail: `Unknown module: ${title}`,
    });
    return;
  }
  if (!containerId) {
    toast.current?.show({
      severity: "info",
      summary: "Info",
      detail: "Module instance hasn't been created yet",
    });
    return;
  }

  if (
    currentStatus !== "RUNNING" &&
    !checkDependencies(title, cardStatus, toast)
  )
    return;

  setLoading((prev) => ({ ...prev, [title]: true }));
  try {
    const action = currentStatus === "RUNNING" ? "stop" : "start";
    const responseData = await toggleSingle(
      title,
      action,
      config,
      containerId,
      toast,
    );
    const instance = extractInstance(responseData, config, title, containerId);

    setContainerIds((prev) => ({
      ...prev,
      [title]: instance.containerId || containerId,
    }));
    setCardStatus((prev) => ({
      ...prev,
      [title]:
        currentStatus === "RUNNING" ? "STOPPED" : instance.status || "RUNNING",
    }));
    if (instance.exposedPorts)
      setExposedPorts((prev) => ({ ...prev, [title]: instance.exposedPorts }));

    toast.current?.show({
      severity: "success",
      summary: "Success",
      detail: currentStatus === "RUNNING" ? config.stopMsg : config.startMsg,
    });
  } catch (error) {
    if (error.response?.status === 403) {
      toast.current?.show({
        severity: "error",
        summary: "Permission Denied",
        detail: "You don't have permission to access this resource",
      });
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: `Failed to ${currentStatus === "RUNNING" ? "Stop" : "Start"} Instance`,
      });
    }
    console.error("Error during toggleStatus:", error);
  } finally {
    setLoading((prev) => ({ ...prev, [title]: false }));
  }
};
